import classNames from 'classnames'

import { isValidElementType } from '../../../../utils/common'
import { Avatar } from '../../../Avatar'
import { IconNG } from '../../../Icon'
import { getTagActionSize, Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../../Tag'
import {
  getEmailRecipientAvatarIcon,
  getEmailRecipientFieldSelectItemIcon,
  isEmailRecipientAdditional,
} from '../EmailRecipientsField.utils'

import { getTagName, isErrorEmail } from './RecipientTag.utils'

import * as styles from './RecipientTag.module.css'

function RecipientTag({
  className = styles.RecipientTag,
  disabled,
  errorItems,
  errorOptionKeys,
  isOpen,
  item,
  printer,
  qaName,
  tooltip,
  onDeleteOption,
}) {
  const additional = isEmailRecipientAdditional(item)

  function handleClose() {
    return onDeleteOption(item)
  }

  const tagClassName = classNames(className, {
    [styles.additional]: additional,
    [styles.closedTag]: !isOpen,
    [styles.disabled]: disabled,
  })

  const isErrorItem = isErrorEmail(errorItems, item, printer, errorOptionKeys)

  const tagName = getTagName(item, printer)

  const height = isOpen ? TAG_HEIGHT.height24 : TAG_HEIGHT.height32
  const actionSize = getTagActionSize(height)

  // A draft restored from localStorage loses its avatar `Icon` component to
  // JSON serialization, leaving a broken object behind. Keep a valid live icon
  // as-is; otherwise rebuild it from the serializable item data.
  const AvatarIcon = isValidElementType(item.avatar?.Icon)
    ? item.avatar.Icon
    : getEmailRecipientAvatarIcon(item)

  const beforeContent =
    !isOpen && (item.avatar || item.fullname) ? (
      <Avatar
        {...item.avatar}
        Icon={AvatarIcon}
        size={item.avatar?.size ?? actionSize}
      />
    ) : null

  const afterContent =
    !isOpen && additional ? (
      <IconNG
        Icon={getEmailRecipientFieldSelectItemIcon(item)}
        size={actionSize}
      />
    ) : null

  return (
    <Tag
      afterContent={afterContent}
      appearance={isOpen ? TAG_APPEARANCE.filled : TAG_APPEARANCE.outlined}
      beforeContent={beforeContent}
      className={tagClassName}
      height={height}
      isDisabled={disabled}
      isError={isErrorItem}
      qaName={qaName}
      text={tagName}
      tooltip={tooltip || tagName}
      onRemove={isOpen ? handleClose : undefined}
    />
  )
}

export default RecipientTag
